"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LiveTickerMessage = _interopRequireDefault(require("./LiveTickerMessage.scss"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _core = require("@material-ui/core");

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _moment = _interopRequireDefault(require("moment"));

var _VideoHelper = require("../../../helpers/VideoHelper");

var _Video = _interopRequireDefault(require("../Video/Video"));

var _UrlHelper = _interopRequireDefault(require("../../../helpers/UrlHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var LiveTickerMessage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LiveTickerMessage, _React$Component);

  var _super = _createSuper(LiveTickerMessage);

  function LiveTickerMessage(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LiveTickerMessage);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getVideoSrc", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var videoData, finalUrl;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                videoError: null
              });

              if (_DeviceInfoHelper["default"].isOnline()) {
                _context.next = 4;
                break;
              }

              _this.setState({
                videoError: {
                  message: 'Sie sind offline. Bitte gehen Sie online und versuchen Sie es erneut.'
                }
              });

              return _context.abrupt("return");

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return (0, _VideoHelper.getVideoUrl)(_this.props.videoId);

            case 7:
              videoData = _context.sent;
              finalUrl = _this._correctProtocol(videoData.src);
              console.log('finalUrl', finalUrl, videoData.src);

              _this.setState({
                optimalVideoSrc: finalUrl,
                posterImage: videoData.poster
              });

              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](4);

              _this.setState({
                videoError: _context.t0.message
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 13]]);
    })));
    _this.state = {
      quotedMessage: null,
      optimalVideoSrc: null,
      videoError: null,
      posterImage: null
    };
    return _this;
  }

  (0, _createClass2["default"])(LiveTickerMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.videoId) {
        this.getVideoSrc();
      }
    }
  }, {
    key: "_correctProtocol",
    value: function _correctProtocol(url) {
      var protocol = window.location.protocol.toLowerCase();

      if (protocol === 'file:' || protocol === 'https:' || protocol === 'http:') {
        var parts = _UrlHelper["default"].parseURL(url);

        var protocolToUse = protocol === 'file:' ? 'https:' : protocol;
        var host = protocol === 'https:' && parts.host.match(/:80$/) ? parts.host.substring(0, parts.host.length - 3) : protocol === 'http:' && parts.host.match(/:443$/) ? parts.host.substring(0, parts.host.length - 4) : parts.host;
        return protocolToUse + '//' + host + (parts.pathname.substring(0, 1) !== '/' ? '/' : '') + parts.pathname + parts.search + parts.hash;
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var message = _dompurify["default"].sanitize(this.props.message);

      return /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _LiveTickerMessage["default"].outer,
        key: "entry_".concat(message.id),
        id: message.id,
        style: this.props.isHidden ? {
          padding: 0,
          margin: 0,
          maxHeight: 0
        } : {
          padding: '7px',
          margin: '10px 0',
          maxHeight: '9999px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '20%',
          display: 'inline-block',
          verticalAlign: 'top',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].author : _LiveTickerMessage["default"].authorMobile,
        color: "textSecondary",
        gutterBottom: true
      }, this.props.author), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].date : _LiveTickerMessage["default"].dateMobile,
        color: "textSecondary",
        gutterBottom: true
      }, (0, _moment["default"])(this.props.dateCreated).format('DD.MM.YYYY HH:mm'))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '80%',
          display: 'inline-block',
          padding: 0,
          paddingLeft: 10,
          verticalAlign: 'top'
        }
      }, this.props.videoId && this.state.optimalVideoSrc ? /*#__PURE__*/_react["default"].createElement(_Video["default"], {
        videoId: this.props.videoId,
        poster: this.state.posterImage,
        playsInline: true,
        style: {
          width: '100%',
          height: 'auto',
          display: 'block',
          position: 'relative',
          paddingBottom: '8px'
        },
        controls: true,
        src: this.state.optimalVideoSrc
      }) : null, this.props.videoId && !this.state.optimalVideoSrc && !this.state.videoError ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, null), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingLeft: '10px'
        }
      }, "Video wird geladen")) : null, this.props.videoId && this.state.videoError ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: 'red'
        }
      }, "Video konnte nicht geladen werden - Fehler: ".concat(this.state.videoError)), /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this.getVideoSrc
      }, "Erneut versuchen")) : null, this.props.imageLink ? /*#__PURE__*/_react["default"].createElement("img", {
        style: {
          width: '100%',
          height: 'auto',
          display: 'block',
          position: 'relative',
          paddingBottom: '8px'
        },
        src: this.props.imageLink
      }) : null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].message : _LiveTickerMessage["default"].messageMobile,
        color: "textSecondary",
        gutterBottom: true,
        dangerouslySetInnerHTML: {
          __html: message
        }
      })));
    }
  }]);
  return LiveTickerMessage;
}(_react["default"].Component);

LiveTickerMessage.propTypes = {
  id: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  key: _propTypes["default"].string,
  message: _propTypes["default"].string,
  dateCreated: _propTypes["default"].string,
  dateEdited: _propTypes["default"].string,
  isLatest: _propTypes["default"].bool,
  author: _propTypes["default"].string,
  imageLink: _propTypes["default"].string,
  videoId: _propTypes["default"].string,
  isHidden: _propTypes["default"].bool
};
LiveTickerMessage.defaultProps = {
  isLatest: false,
  isExpert: false
};
var _default = LiveTickerMessage;
exports["default"] = _default;